import types from '../mutation-types';
import Vue from 'vue';
import CustomSurveysAPI from '../../api/customSurveys';

export const state = {
  records: [],
  surveyRecords: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isEditing: false,
  },
};

export const getters = {
  getAllModels(_state) {
    return _state.records;
  },
  getAllSurveys(_state) {
    return _state.surveyRecords;
  },
  getSurvey: _state => id => {
    return _state.surveyRecords.find(record => record.uuid === id) || {};
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async getModel({ commit }) {
    commit(types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES_UI_FLAG, {
      isFetching: true,
    });
    try {
      const { data } = await CustomSurveysAPI.getModels();
      commit(types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  async getSurvey({ commit }) {
    commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await CustomSurveysAPI.getSurvey();
      commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  async createModel({ commit }, payload) {
    commit(types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES_UI_FLAG, {
      isCreating: true,
    });
    try {
      const { data } = await CustomSurveysAPI.createModel(payload);
      commit(types.ADD_CUSTOM_SURVEYS_MODELS_ACTIVITY, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES_UI_FLAG, {
        isCreating: false,
      });
    }
  },
  async sendMail({ commit }, payload) {
    commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await CustomSurveysAPI.sendMail(payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, {
        isCreating: false,
      });
    }
  },

  async createSurvey({ commit }, payload) {
    commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await CustomSurveysAPI.createSurvey(payload);
      commit(types.ADD_CUSTOM_SURVEYS_ACTIVITY, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, {
        isCreating: false,
      });
    }
  },

  async updateModel({ commit }, payload) {
    commit(types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES_UI_FLAG, {
      isEditing: true,
    });
    try {
      const { data } = await CustomSurveysAPI.updateModel(payload);
      commit(types.EDIT_CUSTOM_SURVEYS_MODELS_ACTIVITY, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES_UI_FLAG, {
        isEditing: false,
      });
    }
  },

  async deleteSurvey({ commit }, id) {
    commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, { isDeleting: true });
    try {
      await CustomSurveysAPI.deleteSurvey(id.id);
      commit(types.DELETE_CUSTOM_SURVEYS_ACTIVITY, id.id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, {
        isDeleting: false,
      });
    }
  },

  async deleteModel({ commit }, id) {
    commit(types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES_UI_FLAG, {
      isDeleting: true,
    });
    try {
      await CustomSurveysAPI.deleteModel(id.id);
      commit(types.DELETE_CUSTOM_SURVEYS_MODELS_ACTIVITY, id.id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES_UI_FLAG, {
        isDeleting: false,
      });
    }
  },
  async deleteResponse({ commit }, id) {
    commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, { isDeleting: true });
    try {
      await CustomSurveysAPI.deleteResponse(id.id);
      commit(types.DELETE_CUSTOM_SURVEYS_ACTIVITY, id.id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG, {
        isDeleting: false,
      });
    }
  },

  async getEmbedScript(_context, { id, settings }) {
    const { data } = await CustomSurveysAPI.getEmbedScript(id, settings);
    return data.script;
  },
};

export const mutations = {
  [types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CUSTOM_SURVEYS_ACTIVITIES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.ADD_CUSTOM_SURVEYS_MODELS_ACTIVITY]($state, data) {
    $state.records.push(data);
  },
  [types.ADD_CUSTOM_SURVEYS_ACTIVITY]($state, data) {
    $state.surveyRecords.push(data);
  },

  [types.SET_CUSTOM_SURVEYS_ACTIVITIES]($state, data) {
    $state.surveyRecords = data;
  },

  [types.SET_CUSTOM_SURVEYS_MODELS_ACTIVITIES]($state, data) {
    $state.records = data;
  },
  [types.EDIT_CUSTOM_SURVEYS_MODELS_ACTIVITY](state, data) {
    const index = state.records.findIndex(activity => activity.id === data.id);
    if (index !== -1) {
      Vue.set(state.records, index, data);
    }
  },
  [types.DELETE_CUSTOM_SURVEYS_MODELS_ACTIVITY]($state, id) {
    $state.records = $state.records.filter(activity => activity.id !== id);
  },
  [types.DELETE_CUSTOM_SURVEYS_ACTIVITY]($state, id) {
    $state.surveyRecords = $state.surveyRecords
      .filter(survey => survey.id !== id)
      .map(survey => {
        return {
          ...survey,
          responses: survey.responses.filter(response => response.id !== id),
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
